import { render, staticRenderFns } from "./lg-modal.vue?vue&type=template&id=035687b6&scoped=true&"
import script from "./lg-modal.vue?vue&type=script&lang=js&"
export * from "./lg-modal.vue?vue&type=script&lang=js&"
import style0 from "./lg-modal.vue?vue&type=style&index=0&id=035687b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035687b6",
  null
  
)

export default component.exports